const required = (value, message) => {
    return value ? null : (message ?? 'Zorunlu alan!')
}

export default required